import { useActiveBranch } from '@/features/auth/hooks/use-active-branch';
import { isBranchSubscriptionExpired } from '@/features/auth/utils/is-branch-subscription-expired';

/**
 * Whether the active branch subscription has expired (expireDate < today).
 * Derived from persisted branchDetail — cleared automatically on logout.
 */
export function useIsBranchSubscriptionExpired(): boolean {
  const { branchCode, branchDetail } = useActiveBranch();
  return isBranchSubscriptionExpired(branchDetail, branchCode);
}
